import {
    DTOCardFormField,
    NestedField,
} from 'app/types/form.types'
import {
    CreditNoteReasons,
    InvoiceDesignation,
    InvoiceStatus,
    InvoiceType,
} from 'app/enums/label.enums'
import MONTHS_BY_NUMBER from 'app/utils/monthsByNumber'
import {
    LongTermLeaseInvoiceType,
} from 'app/requests/LongTermLeaseInvoice/LongTermLeaseInvoice.types'

const getInvoiceFields = ({
    getAllowedValues,
    originalInvoiceAllowedValues,
    isCreditNote,
}: {
    getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
    originalInvoiceAllowedValues: Record<string, string>,
    isCreditNote: boolean,
}): DTOCardFormField<keyof LongTermLeaseInvoiceType>[] => {
    return [{
        title: 'INVOICE',
        className: 'invoice',
        id: 'invoice',
        fields: [
            {
                id: 'invoice-column1',
                fields: [
                    {
                        name: 'invoiceDesignation',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(InvoiceDesignation),
                        disabled: true,
                        labelKey: 'INVOICE_DESIGNATION',
                    },
                    ...isCreditNote ? [
                        {
                            name: 'creditNoteOriginalInvoice',
                            componentName: 'ObjectSelect',
                            allowedValues: originalInvoiceAllowedValues,
                            required: true,
                            noNone: true,
                            labelKey: 'ORIGINAL_INVOICE',
                        },
                        {
                            name: 'creditNoteReason',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(CreditNoteReasons),
                            useDropdown: true,
                            required: true,
                            noNone: true,
                            labelKey: 'CREDIT_NOTE_REASON',
                        },
                    ] as NestedField<keyof LongTermLeaseInvoiceType>[] : [],
                    {
                        name: 'invoiceType',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(InvoiceType),
                        labelKey: 'INVOICE_TYPE',
                    },
                ],
            },
            {
                id: 'invoice-column2',
                fields: [
                    {
                        name: 'billedMonth',
                        componentName: 'Select',
                        allowedValues: MONTHS_BY_NUMBER,
                        required: true,
                        noNone: true,
                        labelKey: 'BILLED_MONTH',
                    },
                    {
                        name: 'billedYear',
                        componentName: 'IntegerInput',
                        required: true,
                        labelKey: 'BILLED_YEAR',
                    },
                    {
                        name: 'invoiceDate',
                        componentName: 'DateSelect',
                        required: true,
                        labelKey: 'INVOICE_DATE',
                    },
                ],
            },
            {
                id: 'invoice-column3',
                fields: [{
                    name: 'invoiceComment',
                    componentName: 'LongText',
                    labelKey: 'INVOICE_COMMENT',
                }],
            },
            {
                id: 'invoice-column4',
                fields: [
                    {
                        name: 'invoiceSentToSapOn',
                        componentName: 'DateSelect',
                        disabled: true,
                        labelKey: 'SENT_TO_SAP_ON',
                    },
                    {
                        name: 'changedBy',
                        componentName: 'InputSingleline',
                        disabled: true,
                        labelKey: 'CHANGED_BY',
                    },
                    {
                        name: 'invoiceStatus',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(InvoiceStatus),
                        disabled: true,
                        labelKey: 'INVOICE_STATUS',
                    },
                ],
            },
        ],
    }]
}

export default getInvoiceFields
